import React, { useEffect, useState } from "react";
import { axios } from "../../../../../../Global";
import { setAppError, setBreadCrumb } from "../../../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  Link,
  useLocation,
  useNavigate,
  useOutletContext,
} from "react-router-dom";
import PromptElement from "../../../../PromptElement";
import ListDataTermsAndCondition from "./ListDataTermsAndCondition";
import AddEditFormTermsAndCondition from "./AddEditFormTermsAndCondition";
import { printValidationError } from "../../../../../../utils/functions";
import { checkAccessFn } from "../../../../../../utils/checkAccess";

export default function QuotationCostTermsAndCondition(props) {
  const outletContext = useOutletContext();
  const [showPromptElement, setShowPromptElement] = useState({
    open: false,
    id: null,
  });
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [termsUpdate, setTermsUpdate] = useState(false);
  const [submitFormLoading, setSubmitFormLoading] = useState(false);
  const [loading, setLoading] = useState({
    edit: false,
    delete: false,
    listData: false,
    loadingId: "",
  });
  const [clientList, setClientList] = useState([]);
  const [addOrEdit, setAddOrEdit] = useState({
    open: false,
    method: "",
    loadedValues: {},
    editId: "",
  });

  const currentQuotationId =
    location.state?.quotationId || location.pathname.split("/")[3];

  useEffect(() => {
    if (location.pathname.split("/").at(-1) == "terms") {
      dispatch(
        setBreadCrumb([
          { label: "QUOTATION", link: "/dashboard/quotation" },
          {
            label: String(
              outletContext?.quotationNumber || "COST SHEETS"
            )?.toUpperCase(),
            link: `/dashboard/quotation/${currentQuotationId}`,
          },
          {
            label: "TERMS AND CONDITIONS",
            link: ``,
          },
        ])
      );
    }
  }, [outletContext?.quotationNumber, location.pathname]);

  useEffect(() => {
    if (location.pathname.split("/")[5] === "create") {
      setAddOrEdit((p) => ({ ...p, open: true, method: "add" }));
    } else {
      setAddOrEdit((p) => ({ ...p, open: false }));
    }
  }, [location]);

  const [particulars, setParticulars] = useState("");
  const [remarks, setRemarks] = useState("");
  const [status, setStatus] = useState("");

  const token = localStorage.getItem("token");
  const quotationCostSheetId = location.pathname.split("/").at(3);

  useEffect(() => {
    axios
      .get(
        `/dashboard/quotation-terms-and-condition-list/${quotationCostSheetId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setClientList(res.data.data);
      })
      .catch((err) => {
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      });
  }, [termsUpdate, addOrEdit.open, loading.delete]);

  const submitForm = async (event) => {
    event.preventDefault();
    setSubmitFormLoading(true);
    try {
      let response;
      const body = {
        particulars,
        remark: remarks,
        quotation_id: quotationCostSheetId,
      };
      if (addOrEdit.method === "add") {
        response = await axios.post(
          `/dashboard/quotation-terms-and-condition`,
          body,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      } else if (addOrEdit.method === "edit") {
        response = await axios.put(
          `/dashboard/quotation-terms-and-condition/${addOrEdit.editId}`,
          { particulars, remark: remarks },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      }
      const data = response.data.data;
      if (data) {
        navigate(`/dashboard/quotation/${quotationCostSheetId}/terms`);
        dispatch(
          setAppError({
            msg: response.data.message,
            color: "bg-green-700",
          })
        );
        setSubmitFormLoading(false);
        setAddOrEdit((p) => ({ ...p, open: false }));
      }
    } catch (err) {
      console.log(err);
      printValidationError(err, "termsAndCondition");
      setSubmitFormLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };
  const cancelForm = () => {
    navigate(`/dashboard/quotation/${quotationCostSheetId}/terms`);

    setAddOrEdit((p) => ({ ...p, open: false }));
  };
  const editData = async (id) => {
    navigate(`/dashboard/quotation/${quotationCostSheetId}/terms#edit-${id}`);

    if (id) {
      setLoading((p) => ({ ...p, edit: true, loadingId: id }));
      try {
        const response = await axios.get(
          `/dashboard/quotation-terms-and-condition/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const data = response.data.data;
        setLoading((p) => ({ ...p, edit: false, loadingId: "" }));
        setAddOrEdit((p) => ({
          ...p,
          open: true,
          method: "edit",
          // loadedValues: data,
          editId: id,
        }));
        setParticulars(data.particulars);
        setRemarks(data.remark);
        setStatus(data.status);
      } catch (err) {
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      }
    }
  };
  const deleteData = async (id) => {
    if (id) {
      setLoading((p) => ({ ...p, delete: true, loadingId: id }));
      try {
        const response = await axios.delete(
          `/dashboard/quotation-terms-and-condition/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (response.status === 200) {
          setLoading((p) => ({ ...p, delete: false, loadingId: "" }));
          dispatch(
            setAppError({
              msg: response.data.message,
              color: "bg-green-700",
            })
          );
        }
      } catch (err) {
        console.log(err);
        setLoading((p) => ({ ...p, delete: false }));

        dispatch(
          setAppError({
            msg: err.message,
          })
        );
        if (err?.response?.status === 403) {
          if (err?.response?.data?.message) {
            dispatch(
              setAppError({
                msg: err?.response?.data.message,
              })
            );
          }
        }
      }
    }
  };

  const addData = () => {
    setAddOrEdit((p) => ({ ...p, open: true, method: "add" }));
    setRemarks("");
    setParticulars("");
    setStatus("");
  };

  const onStatusChanger = async (e, id) => {
    const value = e.target.checked ? "Active" : "Inactive";
    const body = {
      status: value,
    };
    try {
      const response = await axios.put(
        `/dashboard/quotation-terms-and-condition/${id}`,
        body,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status == 200) {
        setTermsUpdate((prev) => !prev);

        dispatch(
          setAppError({
            msg: `${response.data.message}`,
            color: "success",
          })
        );
      }
    } catch (error) {
      setTermsUpdate((prev) => !prev);

      dispatch(setAppError({ msg: `${error.data.message}` }));
    }
  };

  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);

  return (
    <>
      {showPromptElement.open && (
        <PromptElement
          showPromptElement={showPromptElement}
          setShowPromptElement={setShowPromptElement}
          deleteHandler={deleteData}
        />
      )}
      <div className={`p-2  sm:p-5 `}>
        {!addOrEdit.open && (
          <>
            {checkAccess("Quotation", "quotation-cost-sheet-create") && (
              <Link
                to={`/dashboard/quotation/${quotationCostSheetId}/terms/create`}
              >
                <button
                  className="p-2 bg-red text-white rounded-md"
                  onClick={addData}
                >
                  Add New Terms +
                </button>
              </Link>
            )}
            <ListDataTermsAndCondition
              list={clientList}
              editData={editData}
              deleteData={setShowPromptElement}
              onStatusChanger={onStatusChanger}
              loading={loading}
              column={5}
              titles={["SL No.", "Particulars", "Remarks", "Status", "Action"]}
              component="quotation-terms"
            />
          </>
        )}
        {addOrEdit.open && (
          <AddEditFormTermsAndCondition
            form={[
              {
                type: "text",
                text: "Particulars",
                name: "particulars",
                value: particulars,
                update: setParticulars,
                columnName: "particulars",
              },
              {
                type: "textarea",
                text: "Remarks",
                name: "remarks",
                value: remarks,
                update: setRemarks,
                columnName: "remarks",
              },
            ]}
            submitForm={submitForm}
            cancelForm={cancelForm}
            submitFormLoading={submitFormLoading}
            loadedValues={addOrEdit.method === "edit" && addOrEdit.loadedValues}
            quotationNumber={outletContext?.quotationNumber}
            currentQuotationId={currentQuotationId}
          />
        )}
      </div>
    </>
  );
}
